/**
 * Utility functions for formatting numbers and amounts
 */

/**
 * Format amount with appropriate decimal precision
 * @param {number} amount - The amount to format
 * @param {number} decimals - Number of decimal places (default: 8)
 * @returns {string} Formatted amount string
 */
export const formatAmount = (amount, decimals = 8) => {
  if (amount === null || amount === undefined) {
    return '0.' + '0'.repeat(decimals);
  }
  return Number(amount).toFixed(decimals);
};

/**
 * Format price with 8 decimal precision
 * @param {number} price - The price to format
 * @returns {string} Formatted price string
 */
export const formatPrice = (price) => {
  return formatAmount(price, 8);
};

/**
 * Format percentage with 2 decimal precision
 * @param {number} percentage - The percentage to format
 * @returns {string} Formatted percentage string
 */
export const formatPercentage = (percentage) => {
  if (percentage === null || percentage === undefined) {
    return '0.00';
  }
  return Number(percentage).toFixed(2);
};

/**
 * Format balance with 6 decimal precision
 * @param {number} balance - The balance to format
 * @returns {string} Formatted balance string
 */
export const formatBalance = (balance) => {
  return formatAmount(balance, 6);
};

/**
 * Smart amount formatting - removes trailing zeros for better readability
 * @param {number} amount - The amount to format
 * @param {number} maxDecimals - Maximum decimal places (default: 8)
 * @returns {string} Formatted amount string without trailing zeros
 */
export const formatAmountSmart = (amount, maxDecimals = 8) => {
  if (amount === null || amount === undefined) {
    return '0';
  }
  
  const formatted = Number(amount).toFixed(maxDecimals);
  // Remove trailing zeros and unnecessary decimal point
  return formatted.replace(/\.?0+$/, '');
};

/**
 * Get the correct token display name based on network
 * @param {string} networkId - The network ID
 * @returns {string} The token display name
 */
export const getTokenDisplayName = (networkId) => {
  if (networkId === "97") {
    return "CAKE"; // BSC Testnet uses CAKE as GTAI fallback
  }
  return "GTAI"; // BSC Mainnet uses GTAI
};

/**
 * Get token display with network context
 * @param {string} networkId - The network ID
 * @returns {string} The token display with context
 */
export const getTokenDisplayWithContext = (networkId) => {
  if (networkId === "97") {
    return "CAKE (GTAI fallback)";
  }
  return "GTAI";
}; 